<div class="skeleton-line">
  <span></span>
  <span></span>
</div>
